/* EyeBuddy Wishlist — client. localStorage source of truth; syncs to the account (/apps/wishlist) when logged in. */
(function () {
  var LS_KEY = 'eb_wishlist';
  var loggedIn = !!window.EB_WISHLIST_LOGGED_IN;

  function read() { try { return JSON.parse(localStorage.getItem(LS_KEY)) || []; } catch (e) { return []; } }
  function write(list) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(list)); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('eb:wishlist:change', { detail: { count: list.length } })); } catch (e) {}
    updateCounts(list.length);
  }
  function has(list, id) { return list.some(function (i) { return String(i.id) === String(id); }); }
  function gidToId(g) { var m = String(g).match(/(\d+)$/); return m ? m[1] : null; }

  function api(path, opts) {
    return fetch('/apps/wishlist' + (path || ''), Object.assign({ headers: { 'Content-Type': 'application/json' } }, opts || {}))
      .then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  function updateCounts(n) {
    document.querySelectorAll('[data-eb-wishlist-count]').forEach(function (el) {
      el.textContent = n; el.style.display = n > 0 ? '' : 'none';
    });
  }

  function paint(btn, active) {
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var t = btn.querySelector('[data-eb-wishlist-label]');
    if (t) t.textContent = active ? (btn.getAttribute('data-label-active') || 'Liked') : (btn.getAttribute('data-label-idle') || 'Like');
  }
  function paintAll() {
    var list = read();
    document.querySelectorAll('[data-eb-wishlist-btn]').forEach(function (btn) {
      paint(btn, has(list, btn.getAttribute('data-product-id')));
    });
    updateCounts(list.length);
  }

  function toggle(btn) {
    var id = btn.getAttribute('data-product-id');
    var handle = btn.getAttribute('data-product-handle');
    var list = read();
    var active = has(list, id);
    if (active) list = list.filter(function (i) { return String(i.id) !== String(id); });
    else list.push({ id: id, handle: handle });
    write(list);
    // repaint every button for this product (card + PDP can coexist)
    document.querySelectorAll('[data-eb-wishlist-btn][data-product-id="' + id + '"]').forEach(function (b) { paint(b, !active); });
    if (loggedIn) api('', { method: 'POST', body: JSON.stringify({ productId: id, action: active ? 'remove' : 'add' }) });
    // on the likes page, remove the card when un-liked
    if (active) { var card = btn.closest('[data-eb-wishlist-card]'); if (card) card.remove(); refreshEmptyState(); }
  }

  // Merge guest localStorage into the account on login, then adopt the account list.
  function syncOnLogin() {
    if (!loggedIn) return;
    var list = read();
    api('/merge', { method: 'POST', body: JSON.stringify({ items: list.map(function (i) { return i.id; }) }) })
      .then(function (res) {
        if (!res || !res.items) return;
        var byId = {}; list.forEach(function (i) { byId[String(i.id)] = i; });
        write(res.items.map(function (g) { var id = gidToId(g); return byId[id] || { id: id, handle: null }; }));
        paintAll();
      });
  }

  function money(cents) { try { return '$' + (cents / 100).toFixed(2); } catch (e) { return ''; } }
  function cardHTML(p) {
    var img = p.featured_image ? p.featured_image + '&width=400' : '';
    return '<div class="eb-wl-card" data-eb-wishlist-card>'
      + '<a href="/products/' + p.handle + '" class="eb-wl-card__media">' + (img ? '<img loading="lazy" src="' + img + '" alt="' + (p.title || '').replace(/"/g, '') + '">' : '') + '</a>'
      + '<button type="button" class="eb-wl-card__heart is-active" onclick="if(window.ebWishlistToggle){window.ebWishlistToggle(this);}return false;" data-eb-wishlist-btn data-product-id="' + p.id + '" data-product-handle="' + p.handle + '" aria-pressed="true" aria-label="Remove from likes">♥</button>'
      + '<a href="/products/' + p.handle + '" class="eb-wl-card__title">' + (p.title || '') + '</a>'
      + '<div class="eb-wl-card__price">' + money(p.price) + '</div>'
      + '</div>';
  }
  function refreshEmptyState() {
    var mount = document.querySelector('[data-eb-wishlist-list]');
    var empty = document.querySelector('[data-eb-wishlist-empty]');
    if (!mount || !empty) return;
    empty.style.display = mount.querySelector('[data-eb-wishlist-card]') ? 'none' : '';
  }
  function renderLikesPage() {
    var mount = document.querySelector('[data-eb-wishlist-list]');
    if (!mount) return;
    if (mount.getAttribute('data-server-rendered') === 'true') { paintAll(); return; }
    var list = read().filter(function (i) { return i.handle; });
    if (!list.length) { refreshEmptyState(); return; }
    Promise.all(list.map(function (i) {
      return fetch('/products/' + i.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (prods) {
      prods.filter(Boolean).forEach(function (p) { mount.insertAdjacentHTML('beforeend', cardHTML(p)); });
      refreshEmptyState();
      paintAll();
    });
  }

  // Primary activation = inline onclick on each heart (calls this global). Reliable regardless of the
  // gallery's Alpine @click / native scroll swallowing delegated events.
  window.ebWishlistToggle = function (btn) { if (btn) toggle(btn); };
  // Fallback delegation for any heart WITHOUT an inline onclick (won't double-fire the inline ones).
  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('[data-eb-wishlist-btn]') : null;
    if (!btn || btn.getAttribute('onclick')) return;
    e.preventDefault();
    toggle(btn);
  }, true);
  function boot() { paintAll(); syncOnLogin(); renderLikesPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
